import { useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import {
  extractInfoFromInfiniteData,
  extractListRecords,
  extractPropertyFromListRecords,
} from "../utils";
import { handleGetPopularGames } from "../../api-clients/gamesClient";
import { Game, PopularGame } from "@nestcoinco/hyper-api-gateway-api-client";

interface UseInfinitePopularGamesQueryParams {
  enabled?: boolean;
  limit?: number;
  maxPages?: number;
}

function useInfinitePopularGamesQuery(
  params?: UseInfinitePopularGamesQueryParams,
) {
  const { enabled, limit, maxPages } = params || {};

  const query = useInfiniteQuery({
    queryKey: [QUERY_KEYS.GAME.POPULAR_GAMES],
    queryFn: ({ pageParam }) =>
      handleGetPopularGames({ page: pageParam, limit }),
    initialPageParam: 1,
    maxPages,
    getNextPageParam: (lastPage) => lastPage.nextPage,
    getPreviousPageParam: (firstPage) => firstPage.previousPage,
    enabled,
  });

  const popularGamesList = useMemo(
    () => extractInfoFromInfiniteData(query.data),
    [query.data],
  );

  const popularGamesData = useMemo(
    () => extractListRecords(popularGamesList),
    [popularGamesList],
  );

  const popularGames = useMemo(
    () =>
      extractPropertyFromListRecords<PopularGame, Game>(
        popularGamesData,
        "game",
      ),
    [popularGamesData],
  );

  return { query, popularGames, popularGamesData };
}

export default useInfinitePopularGamesQuery;
